<template>
  <v-container fluid>
    <v-row align="center" justify="center" class="mx-0">
      <v-col cols="12">
        <v-breadcrumbs :items="breadcrumbItems" large></v-breadcrumbs>
      </v-col>
      <v-col cols="12">
        <v-card outlined>
          <div class="d-flex justify-space-between align-center">
            <v-card-title>
              <v-list nav v-if="connection != null">
                <v-list-item>
                  <UserAvatar
                    :key="connection.connectionId"
                    :usersInitials="
                      connection.firstName[0] + connection.lastName[0]
                    "
                    :displayImageUrl="connection.displayImageUrl"
                  />
                  <v-list-item-content>
                    <v-list-item-title>{{
                      connection.firstName + " " + connection.lastName
                    }}</v-list-item-title>
                    <v-list-item-subtitle class="grey--text"
                      >{{
                        connections.length
                      }}
                      connections</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-title>
            <v-sheet width="400" class="px-8">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                outlined
                single-line
                hide-details
                rounded
                dense
                class="text-body"
              ></v-text-field>
            </v-sheet>
          </div>

          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="connections"
              :items-per-page="8"
              :search="search"
              :custom-filter="customSearch"
            >
              <template v-slot:item.firstName="{ item }">
                {{ item.firstName + " " + item.lastName }}
              </template>
              <template v-slot:item.avatar="{ item }">
                <v-list-item>
                  <UserAvatar
                    :key="item.connectionId"
                    :usersInitials="item.firstName[0] + item.lastName[0]"
                    :displayImageUrl="item.displayImageUrl"
                  />
                </v-list-item>
              </template>
              <template v-slot:item.jobTitle="{ item }">
                <div>{{ item.jobTitle ? item.jobTitle : "-" }}</div>
              </template>
              <template v-slot:item.businessName="{ item }">
                <div>{{ item.businessName ? item.businessName : "-" }}</div>
              </template>
              <template v-slot:item.createdOn="{ item }">
                <div>
                  {{
                    item.createdOn
                      ? item.createdOn.toDate().toLocaleDateString()
                      : "-"
                  }}
                </div>
              </template>
              <template slot="header.createdOn">
                <div class="d-inline-flex align-center justify-start">
                  <div>Connected On</div>
                  <v-tooltip bottom max-width="300">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" small class="ml-4"
                        >mdi-information-outline
                      </v-icon>
                    </template>
                    <span
                      >Please note date connection made has only been captured
                      since March, 2022.</span
                    >
                  </v-tooltip>
                </div>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-menu transition="slide-y-transition" bottom left offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                  </template>
                  <v-list nav>
                    <v-list-item @click="handleViewCardClick(item)">
                      <v-list-item-title>View Card</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Utility from "@/shared/utility";
import UserAvatar from "@/components/UserAvatar";
import { mapGetters } from "vuex";
import {where} from "firebase/firestore";

export default {
  data() {
    return {
      dialog: false,
      connections: [],
      headers: [
        { text: "", value: "avatar", align: "start" },
        {
          text: "Name",
          value: "firstName",
          align: "start",
        },
        {
          text: "Job Title",
          value: "jobTitle",
          align: "start",
        },
        {
          text: "Business Name",
          value: "businessName",
          align: "start",
        },
        {
          text: "Connected On",
          value: "createdOn",
          align: "start",
        },
        {
          text: "Actions",
          value: "actions",
          align: "start",
        },
      ],
      businessCardId: "",
      search: "",
      breadcrumbItems: [
        {
          text: "Manage Team",
          disabled: false,
          to: "/cardholders",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["cardHolders"]),
    connection() {
      let connection = this.cardHolders.find(
        (cardholder) => cardholder.businessCardId == this.businessCardId || null
      );
      return connection;
    },
  },
  components: {
    UserAvatar,
  },
  async created() {
    this.businessCardId = this.$route.params.businessCardId;

    this.connections = [];
    let querySnapshot = await getQueryConnectionsCollection(
        where("businessCardIds", "array-contains", this.businessCardId),
        where("isAccepted", "==", true)
    );
    querySnapshot.forEach((documentSnapshot) => {
      let connectionIndex = -1;
      const documentData = documentSnapshot.data();
      if (documentData.businessCardIds[0] == this.businessCardId)
        connectionIndex = 1;
      else if (documentData.businessCardIds[1] == this.businessCardId)
        connectionIndex = 0;
      this.connections.push({
        connectionId: documentSnapshot.id,
        firstName: documentData[`firstName${connectionIndex}`],
        lastName: documentData[`lastName${connectionIndex}`],
        displayImageUrl:
          documentData[`displayImageUrl${connectionIndex}`] == null
            ? ""
            : documentData[`displayImageUrl${connectionIndex}`],
        businessName:
          documentData[`businessName${connectionIndex}`] == null
            ? ""
            : documentData[`businessName${connectionIndex}`],
        jobTitle:
          documentData[`jobTitle${connectionIndex}`] == null
            ? ""
            : documentData[`jobTitle${connectionIndex}`],
        createdOn: documentData.createdOn || "",
        businessCardId: documentData.businessCardIds[connectionIndex] || "",
      });
    });
    this.breadcrumbItems.push({
      text: this.connection.firstName + " " + this.connection.lastName,
      disabled: true,
    });
  },
  methods: {
    customSearch(value, search, item) {
      search = search.toLowerCase();

      return Object.values(item).some((value) => {
        let name = item.firstName + " " + item.lastName;
        return (
          value.toLowerCase().includes(search) ||
          name.toLowerCase().includes(search)
        );
      });
    },
    handleViewCardClick(card) {
      if (card.businessCardId) {
        let url = "https://app.pappyon.com/businessCard/" + card.businessCardId;
        window.open(url, "_blank").focus();
      }
    },
  },
};
</script>

<style>
</style>